// src/components/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Importa useLocation para obtener la ruta actual
import '../styles/Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Obtén la ruta actual

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src="/logo.png" alt="Logo" />
        </Link>
      </div>
      <div className="hamburger-icon" onClick={toggleMenu}>
        ☰
      </div>
      <ul className={`navbar-links ${isOpen ? 'open' : ''}`}>
      <li>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/members" className={location.pathname.startsWith('/members') ? 'active' : ''}>
            Members
          </Link>
        </li>
        <li>
          <Link to="/publications" className={location.pathname === '/publications' ? 'active' : ''}>
            Publications
          </Link>
        </li>
        <li>
          <Link to="/expertise" className={location.pathname === '/expertise' ? 'active' : ''}>
            Expertise
            </Link>
        </li>
        <li>
          <Link to="/thesis" className={location.pathname === '/thesis' ? 'active' : ''}>
            Theses
          </Link>
        </li>
        <li>
          <Link to="/projects" className={location.pathname === '/projects' ? 'active' : ''}>
            Projects
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
